/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CompanyQueryResponse,
  GetApiV1CompanyQueryParams,
  GetApiV1Company400,
  GetApiV1Company401,
  GetApiV1Company500,
} from "../../types/companyListingController/GetApiV1Company.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1Company } from "../../clients/companyListingController/getApiV1Company.ts";

export const getApiV1CompanyQueryKey = (params?: GetApiV1CompanyQueryParams) =>
  [{ url: "/api/v1/company" }, ...(params ? [params] : [])] as const;

export type GetApiV1CompanyQueryKey = ReturnType<
  typeof getApiV1CompanyQueryKey
>;

export function getApiV1CompanyQueryOptions(
  params?: GetApiV1CompanyQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1CompanyQueryKey(params);
  return queryOptions<
    GetApiV1CompanyQueryResponse,
    ResponseErrorConfig<
      GetApiV1Company400 | GetApiV1Company401 | GetApiV1Company500
    >,
    GetApiV1CompanyQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1Company(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista paginada de empresas ativas, ordenadas por nome, para alimentar o dropdown de empresas. O filtro search compara com nome ou código, sem diferenciar maiúsculas de minúsculas, e companyId restringe o resultado a uma empresa. **(Requer Authorization para autenticação)**
 * @summary Listar empresas paginadas (Requer Authorization para autenticação)
 * {@link /api/v1/company}
 */
export function useGetApiV1Company<
  TData = GetApiV1CompanyQueryResponse,
  TQueryData = GetApiV1CompanyQueryResponse,
  TQueryKey extends QueryKey = GetApiV1CompanyQueryKey,
>(
  params?: GetApiV1CompanyQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CompanyQueryResponse,
        ResponseErrorConfig<
          GetApiV1Company400 | GetApiV1Company401 | GetApiV1Company500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getApiV1CompanyQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1CompanyQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1Company400 | GetApiV1Company401 | GetApiV1Company500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
